var vskoAppPopover = angular.module('vskoAppPopover', []);

vskoAppPopover.directive('vskoAppPopover', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-app-popover.html'),
    replace: true,
    transclude: {
      'apps': '?vskoApp'
    },
    scope: {},
    link: function(scope, element, attrs) {
      'use strict';
    }
  }
}]).directive('vskoApp', [function() {
  return {
    template: require('./vsko-app.html'),
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      'name': '@',
      'link': '@'
    },
    link: function($scope, element, attrs) {
      'use strict';
    }
  };
}])
